<template>
  <div class="trainer-preferences trainpreff">
    <CheckboxRow
      v-for="item in opts"
      :key="item.id"
      class="trainpreff_checkbox-row"
      :class="item.css_class"
      style="--clr-row-back: var(--preff-clr-row-back); --clr-btn-back: var(--preff-clr-btn-back)"
      :item="item"
      :hasAny="item.hasAny"
      :isSingle="item.single"
      :checkboxAs="'btn'"
      :style="item.style"
      :open="true"
      :hasContent="item.hasContent"
      :hasInitialUpdate="false"
      :styleCheckbox="`--checkbox-btn-padding: 0rem 0.5rem;--checkbox-btn-back: transparent;`"
      :checkboxClass="item.soon ? 'no-events opacity_7' : ''"
      :data-tst="`trainer_preferences_${item.id}`"
      @update="item => setSelected(item.urlKey, item)"
    >
      <template #title="v">
        <CheckboxLt
          :label="v.item ? v.item.title : ''"
          :tooltip="v.item ? v.item.tooltip : ''"
          :checkboxProps="{
            value: !!item.selected.length,
            hasIcon: item.hasCheckbox,
            disabled: item.checkboxDisabled,
            ...commonCheckboxProps,
          }"
          :class="[item.hasContent ? 'mbs-1' : '']"
          class="gw_hvr"
          style="--hvr-content-opacity: 0.5"
          @click="toggleCheckbox(item.urlKey, item)"
        >
          <template #tooltip>
            <GwTooltip
              class="mr-1 gw_hvr_content my-auto ml-1"
              style="--hvr-content-opacity: 0.5"
              :tooltip="item.tooltip"
            >
              <img
                v-if="item.img && !mobile"
                class="img-tooltip"
                style="width: 20rem; border-radius: 4px"
                :src="getImage(item.img)"
              />
            </GwTooltip>
            <!-- <div
              class="csst gw_hvr_content ml-1 mdi mdi-help-circle-outline clr-grey"
              @click.stop
              @mouseenter="e => fl_positionTooltip(e, { offset: 0, placement: 'top' })"
            >
              <div
                :class="item.tooltip_content_css_class"
                class="csst_content help-title-tooltips clr-white"
                style="position: fixed; max-width: clamp(12rem, 36rem, 96vw)"
              >
                {{ item.tooltip_css_class }}
                <div v-html="item.tooltip"></div>
                <img
                  v-if="item.img && !mobile"
                  class="img-tooltip"
                  style="width: 20rem; border-radius: 4px"
                  :src="getImage(item.img)"
                />
              </div>
            </div> -->
          </template>
          <div
            v-if="item.soon"
            class="soon-tag"
          >
            {{ $t('common.soon') }}
          </div>
          <div
            v-if="item.note"
            class="soon-tag"
          >
            {{ item.note }}
          </div>
        </CheckboxLt>
      </template>
      <template #default="v">
        {{
          item.id === 'fh_rng'
            ? $t(`btn.${v.id}_rng`)
            : item.id === 'fh_trainer_session'
              ? v.id
              : item.id === 'fh_trainer_tables'
                ? v.id
                : item.id === 'fh_trainer_grouping'
                  ? $t(`switchers.${v.id}_difficulty`)
                  : $t(`btn.${v.id}`)
        }}
      </template>
    </CheckboxRow>
  </div>
</template>

<script>
import GwTooltip from '@/components/lib/GwTooltip'
import CheckboxLt from '@/components/Common/Checkbox/CheckboxLt'
import CheckboxRow from '@/components/Forms/CheckboxRow'
import { getFullHandSetupConfig } from '@/store/router/router'
import float_mix from '@/mixins/float_mix'
import links_mix from '@/mixins/links_mix'

export default {
  name: 'TrainerPreferences',
  components: {
    CheckboxRow,
    GwTooltip,
    CheckboxLt,
  },
  mixins: [float_mix, links_mix],
  props: {
    namespace: { String, required: true },
    autoUpdateQuery: { type: Boolean, default: true },
    canCloneSettings: { type: Boolean, default: true },
    hiddenOptions: { type: Array, default: () => null },
    visibleOptions: { type: Array, default: () => null },
    routerParams: {
      type: Object,
      default: () => ({
        push: false,
        replace: false,
        saveLocally: false,
      }),
    },
  },
  data() {
    this.commonCheckboxProps = {
      style: `--clr-disabled:var(--clr-black-3);--clr-enabled:var(--clr-white-0);--icon-size: 1.5rem;--label-size:0.875rem`,
    }
    return {
      openSections: [0],
      l_query: {},
    }
  },
  methods: {
    initialize() {
      const conf = getFullHandSetupConfig()
      const fh = {}
      Object.keys(conf).forEach(key => {
        fh[key] = this.qqfh[key].split(',').filter(i => i)
      })
      if (JSON.stringify(fh) !== JSON.stringify(this.l_query)) {
        this.l_query = fh
      }
    },
    toggleCheckbox(key, item) {
      if (!item.hasCheckbox) return
      const values = [item.options[0]] || ['on']

      if (!item.selected.length) {
        this.triggerFn(item, values, key)
        this.setQuery({ [key]: values })
      } else {
        this.triggerFn(item, [], key)
        this.setQuery({ [key]: [] })
      }
      if (this.autoUpdateQuery) {
        this.apply()
      }
    },
    setSelected(key, item) {
      const values = item.selected
      this.triggerFn(item, values, key)
      this.setQuery({ [key]: values })
      if (this.autoUpdateQuery) {
        this.apply()
      }
    },
    setQuery(params) {
      this.l_query = {
        ...this.l_query,
        ...params,
      }
    },
    triggerFn(item, values, key) {
      if (item.fn) {
        ;[item.fn].flat().forEach(fn => {
          fn(values, key)
        })
      }
    },
    apply() {
      this.updateQuery(this.l_query)
    },
    clear() {
      this.opts.forEach(opt => {
        if (opt.hasCheckbox) {
          this.l_query[opt./*  */ urlKey] = []
        } else {
          this.l_query[opt.urlKey] = [opt.options[0]]
        }
      })
    },
    updateQuery(query) {
      this.$store.dispatch(`${this.namespace}/router_update_query`, {
        query,
        ...this.routerParams,
        // push: false,
        // replace: false,
        // saveLocally: this.namespace === 'tra/alpha',
      })
    },
    cloneToAll(values, key) {
      if (!this.canCloneSettings) return

      const namespaces = ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta']
      namespaces.forEach(nn => {
        if (nn !== this.namespace) {
          this.$store.dispatch(`${nn}/router_update_query`, {
            query: { [key]: values },
            push: false,
            replace: false,
            saveLocally: false,
          })
        }
      })
    },
    startTables(values, key) {
      if (this.configure) return
      if (this.$store.getters.session_finished) return

      const numOfTables = Number(values[0])
      const instances = this.$store.getters.hands_instances

      const liveIst = ['alpha', 'beta', 'gamma', 'delta'].filter((_, idx) => idx <= numOfTables - 1)
      const newInst = liveIst.filter(n => !instances.includes(n))
      const killedInst = instances.filter(ii => !liveIst.includes(ii))
      const unchangedInst = instances.filter(n => liveIst.includes(n))

      if (newInst.length) {
        const newNamespaces = newInst.map(n => `tra/${n}`)
        this.$store.dispatch('hands_start', {
          namespaces: newNamespaces,
          copyModule: true,
          toModuleParams: { fh_trainer_tables: numOfTables },
        })
      }
      if (killedInst.length) {
        const killedNamespaces = killedInst.map(n => `tra/${n}`)
        this.$store.dispatch('hands_stop', { namespaces: killedNamespaces, configure: false })
      }
      if (unchangedInst.length) {
        unchangedInst.forEach((nn, idx) => {
          // unlock possibly locked tables
          if (this.$store.getters[`tra/${nn}/trainer_table_locked`]) {
            this.$store.dispatch(`tra/${nn}/trainer_hand_initialize`, {
              unlock: true,
              fh_trainer_tables: numOfTables,
            })
          }
          setTimeout(() => {
            this.$store.dispatch('globals_action', `horizontal_scroll_check_tra/${nn}`)
          }, 10 * idx)
        })
      }
    },
    clearTimeouts() {
      if (!this.namespace.includes('tmp')) {
        this.$store.dispatch(`hands_clear_timeouts`)
      }
    },
    playConfirmSound(values, key) {
      if (values[0]) {
        this.$store.dispatch(`sounds_play`, 'sounds_enable')
      }
    },
    toggleAllSections(open) {
      if (!open) {
        this.openSections = []
      } else {
        this.openSections = [0, 1, 2, 3, 4]
      }
    },
    toggleSection(open, idx) {
      if (open) {
        this.openSections = this.openSections.filter(item => item !== idx)
      } else {
        this.openSections = [...this.openSections, idx]
      }
    },
    resetResultView() {
      if (!this.namespace.includes('tmp')) {
        const namespaces = ['tra/alpha', 'tra/beta', 'tra/gamma', 'tra/delta']
        namespaces.forEach(nn => {
          const handFinished = this.$store.getters[`${nn}/trainer_hand_finished`]
          const botSpot = this.$store.getters[`${nn}/bot_spot`]
          const resVisible = handFinished || !!botSpot
          // console.log(resVisible, nn)
          this.$store.commit(`${nn}/trainer_set`, {
            key: 'trainer_result_visible',
            value: resVisible,
          })
          this.$store.commit(`${nn}/trainer_set`, {
            key: 'trainer_quick_result_visible',
            value: false,
          })
        })
      }
    },
    getImage(site) {
      return new URL(`/src/assets/img/${site}.webp`, import.meta.url).href
    },
  },
  computed: {
    configure() {
      return this.$store.getters.hands_configure
    },
    opts() {
      const conf = getFullHandSetupConfig()
      const { hotkeys } = this.$store.getters
      let res = [
        {
          id: 'fh_trainer_tables',
          hasCheckbox: false,
          fn: [this.clearTimeouts, this.startTables, this.cloneToAll],
          css_class: this.mobile ? 'no-events' : '',
          checkboxDisabled: !!this.mobile,
          selected: this.mobile ? ['on'] : null,
          note: this.mobile ? this.$t('messages.multitable_disabled') : '',
        },
        {
          id: 'fh_trainer_mode',
          hasAny: false,
          hasCheckbox: false,
          fn: [this.clearTimeouts, this.cloneToAll],
        },
        {
          id: 'fh_trainer_grouping',
          hasAny: false,
          hasCheckbox: false,
          fn: [this.cloneToAll, this.resetResultView],
        },
        {
          id: 'fh_trainer_game_mode',
          hasAny: false,
          hasCheckbox: false,
          fn: [this.cloneToAll, this.resetResultView],
        },
        {
          id: 'fh_trainer_result',
          hasCheckbox: false,
          anyAsOff: true,
          hasAny: true,
          fn: this.cloneToAll,
        },
        {
          id: 'fh_trainer_game_speed',
          hasAny: false,
          hasCheckbox: false,
          fn: [this.cloneToAll],
        },
        {
          id: 'fh_trainer_autoplay',
          hasCheckbox: false,
          anyAsOff: true,
          hasAny: true,
          fn: this.cloneToAll,
        },
        {
          id: 'fh_rng',
          tooltip_content_css_class: 'csst_content_hoverable',
          tooltip: 'rng_tooltip_tra01',
          tooltipProps: {
            linkText: !this.$i18n.g1
              ? `<a target='_blank' class='weight_700 link-underline' href='${this.links_url_links.rng_trainer_preferences.url}'>${this.links_url_links.rng_trainer_preferences.text}</a>`
              : '',
          },
          hasCheckbox: false,
          anyAsOff: true,
          hasAny: true,
        },
        {
          id: 'fh_trainer_learning_mode',
          hasCheckbox: false,
          anyAsOff: true,
          hasAny: true,
          hasContent: true,
          fn: this.cloneToAll,
        },

        {
          id: 'fh_trainer_timebank',
          hasCheckbox: false,
          anyAsOff: true,
          hasAny: true,
          fn: [this.clearTimeouts, this.cloneToAll],
        },
        {
          id: 'fh_trainer_session',
          hasCheckbox: false,
          anyAsOff: true,
          hasAny: true,
          fn: this.cloneToAll,
        },

        {
          id: 'fh_trainer_hero_frequency',
          css_class: 'trainpref_first-checkbox',
          hotkey: hotkeys.practice_hero_frequency.displayCombination,
          fn: this.cloneToAll,
        },
        {
          id: 'fh_trainer_quick_result',
          img: 'trainer_quick_res',
          fn: this.cloneToAll,
        },
        {
          id: 'fh_trainer_streak_visible',
          fn: this.cloneToAll,
        },
        {
          id: 'fh_trainer_rng_visible',
          css_class: this.l_query.fh_rng?.length ? 'no-events' : '',
          checkboxDisabled: !!this.l_query.fh_rng?.length,
          selected: this.l_query.fh_rng?.length ? ['on'] : null,
          note: this.l_query.fh_rng?.length ? this.$t('messages.rng_enabled') : '',
          fn: this.cloneToAll,
        },
        { id: 'fh_trainer_hero_range' },
        { id: 'fh_trainer_opponent_range' },
        { id: 'fh_trainer_equity_chart' },
        { id: 'fh_trainer_ranges_comparison' },
        { id: 'fh_trainer_hand_strength' },
        { id: 'fh_trainer_total_frequency', fn: this.cloneToAll },
        { id: 'fh_trainer_hero_strategy' },
        { id: 'fh_trainer_category_hands' },
        { id: 'fh_trainer_category_draws' },
      ]

      if (this.hiddenOptions) {
        res = res.filter(i => !this.hiddenOptions.includes(i.id))
      }
      if (this.visibleOptions) {
        res = res.filter(i => this.visibleOptions.includes(i.id))
      }

      res = res.map(i => {
        const urlKey = i.id
        const hasCheckbox = 'hasCheckbox' in i ? i.hasCheckbox : true
        const options = conf[urlKey]?.options || []
        const hasContent = 'hasContent' in i ? i.hasContent : options.length > 1
        const style = hasCheckbox ? '--padding-content: 0 0 0 0;--margin-content:0.25rem 0 0 0' : ''
        const selected = i.selected || this.l_query[urlKey] || []
        const r = {
          ...i,
          urlKey,
          hasCheckbox,
          style,
          single: 'single' in i ? i.single : true,
          hasAny: 'hasAny' in i ? i.hasAny : false,
          allDisabled: i.soon,
          title: this.$t(`trainer.${i.title ? i.title : `${i.id.replace('fh_', '')}`}`),
          tooltip: this.$t(
            `trainer.${i.tooltip ? i.tooltip : `${i.id.replace('fh_', '')}_tooltip`}`,
            { key: i.hotkey || '', ...(i.tooltipProps || {}) },
          ),
          selected,
          options,
          hasContent,
        }
        return r
      })
      // console.log(res)
      return res
    },
    qqfh() {
      const res = this.$store.getters[`${this.namespace}/query_fullhand_setup`]
      return res
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
  watch: {
    qqfh: {
      immediate: true,
      handler: 'initialize',
    },
  },
}
</script>
<style lang="scss" scoped>
.trainpreff {
  --preff-clr-row-back: var(--clr-black-1-2);
  --preff-clr-btn-back: var(--clr-black-1-2);
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  &.trainpref_mixed-options {
    .trainpref_first-checkbox {
      margin-top: 0.5rem;
    }
  }
  &_title {
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--clr-grey-2);
    margin-bottom: 0.25rem;
  }
  &_checkbox-row {
    &:first-child {
      margin: 0;
    }
  }
  .help-title-tooltip {
    position: fixed;
    width: max-content;
    max-width: clamp(12rem, 32rem, 96vw);
  }
  .soon-tag {
    padding: 0.1rem 0.25rem;
    font-size: 0.8rem;
    background: var(--clr-black-2);
    border-radius: 4px;
    color: var(--clr-gre-2);
    font-weight: 500;
    text-transform: uppercase;
    line-height: 1.1;
    margin-left: 1rem;
    text-align: center;
  }
}
</style>
